// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"8a0e0778","223":"cdfd6718","630":"41755cbf","740":"403aa380","997":"d7527964"}[chunkId] + ".chunk.js";
};